module.exports = __webpack_public_path__ + "assets/img/sabc_old_logo_footer.webp?a196f3a1a7756e083ad923200fbf7fe8";